import { useMutation } from 'react-query';
import { userApi } from '../../api';

export const useChangePassUser = () => {
  const mutation = useMutation((data: any): any => {
    return userApi.changePassword(data);
  });
  return mutation;
};
